<micro-select-combo #sel
              placeholder="Chat Sender"
              routerBase="chat/chatSenders"
              valueField="msisdn"
              [mode]="mode"
              [(id)]="chatSenderId"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
>
</micro-select-combo>
